export default __webpack_public_path__ + "static/media/0x6f3cc27e17a0f2e52d8e7693ff0d892cea1854bf.4abbe81a.png";